import React, { Suspense} from "react";
import { Route, Routes } from "react-router-dom";
import Loader from "./common/Loader";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ClaraLanding from "./login/ClaraLanding";
import Login from "./login/Login";
import Callback from "./login/Callback";
import PatientSearch from "./dashboard/PatientSearch";
import Dashboard2 from "./dashboard/Dashboard2";
import Chat from "./dashboard/Chat2";
import NotFound from "./login/NotFound";
import QRCodePage from "./dashboard/QRCode";
import Forbidden from "./login/Forbidden";
import QRLogin from "./dashboard/QRLogin";
import VoiceSearch from "./dashboard/VoiceSearch2";

const AppRoutes = () => {
  return (
    <Suspense fallback={<Loader />}>
      <ToastContainer />
      <Routes>
        <Route path="/" element={<ClaraLanding />} />
        <Route path="/login" element={<Login />} />
        <Route path="/callback" element={<Callback />} />
        <Route path="/patient-search" element={<PatientSearch />} />
        <Route path="/dashboard" element={<Dashboard2 />} />
        <Route path="/chat" element={<Chat/>} />
        <Route path="/voice" element={<VoiceSearch/>} />
        <Route path="/qr-login" element={<QRLogin/>} />
        <Route path="/qr" element={<QRCodePage/>} />
        <Route path="/forbidden" element={<Forbidden/>} />
        <Route path="*" element={<NotFound />} />
        </Routes>
    </Suspense>
  );
};

export default AppRoutes;
